import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/progress/styles.scss';export default {
  "progress": "_progress_nt17j_1",
  "bar": "_bar_nt17j_7"
};